import React, { useEffect, useState } from "react";
import { useSite } from "@/context/SiteContext";
import { useMemo } from "react";
import { useEnquiry } from "@/context/EnquiryContext";
import { img } from "@/api";
import { X, Calendar, MapPin } from "lucide-react";

export default function ExhibitionPopup() {
  const site = useSite();
  const { open: openEnquiry } = useEnquiry();
  const exhibition = site ? site.exhibition : null;
  const ex = useMemo(() => exhibition || {}, [exhibition]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!ex || ex.enabled === false) return;
    const key = "ekta_exhibition_seen";
    const seen = ex.frequency === "always" ? false : sessionStorage.getItem(key);
    if (!seen) {
      const t = setTimeout(() => { setShow(true); sessionStorage.setItem(key, "1"); }, 2500);
      return () => clearTimeout(t);
    }
  }, [ex]);

  // Allow closing the popup with the Escape key for accessibility
  useEffect(() => {
    if (!show) return;
    const onKey = (e) => { if (e.key === "Escape") setShow(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [show]);

  if (!show || !ex || ex.enabled === false) return null;
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" style={{ background: "rgba(14,15,20,0.65)" }} onClick={() => setShow(false)}>
      <div className="relative w-full max-w-md rounded-lg bg-white overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="exhibition-popup">
        <button onClick={() => setShow(false)} aria-label="Close" className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md transition-transform hover:scale-105 active:scale-95" style={{ color: "var(--ink)" }} data-testid="exhibition-close"><X size={18} /></button>
        {img(ex.image) && <img src={img(ex.image)} alt={ex.title} className="w-full h-48 object-cover" />}
        <div className="p-6">
          <div className="ekta-eyebrow" style={{ color: "var(--yellow-dark)" }}>Exhibition</div>
          <h3 className="ekta-h2 mt-2" style={{ fontSize: "1.4rem" }}>{ex.title}</h3>
          <p className="mt-2 text-sm" style={{ color: "var(--muted-ink)", lineHeight: 1.6 }}>{ex.description}</p>
          <div className="mt-4 flex flex-wrap gap-4 text-sm" style={{ color: "var(--ink-2)" }}>
            {ex.dates && <span className="inline-flex items-center gap-1.5"><Calendar size={15} style={{ color: "var(--brand-primary)" }} /> {ex.dates}</span>}
            {ex.location && <span className="inline-flex items-center gap-1.5"><MapPin size={15} style={{ color: "var(--brand-primary)" }} /> {ex.location}</span>}
          </div>
          <button onClick={() => { setShow(false); openEnquiry({ contactMode: true }); }} className="ekta-btn ekta-btn-primary w-full mt-5">{ex.cta_text || "Get in Touch"}</button>
        </div>
      </div>
    </div>
  );
}
